
const FONTS = [
    ["'Roboto', sans-serif", "https://fonts.googleapis.com/css?family=Roboto"],
    [
      "'Open Sans', sans-serif",
      "https://fonts.googleapis.com/css?family=Open+Sans"
    ],
    ["'Slabo 27px', serif", "https://fonts.googleapis.com/css?family=Slabo+27px"],
    ["'Trirong', serif", "https://fonts.googleapis.com/css?family=Trirong"],
    [
      "'Roboto Condensed', sans-serif",
      "https://fonts.googleapis.com/css?family=Roboto+Condensed"
    ],
    [
      "'Roboto Slab', serif",
      "https://fonts.googleapis.com/css?family=Roboto+Slab"
    ],
    ["'Rubik', sans-serif", "https://fonts.googleapis.com/css?family=Rubik"],
    [
      "'Open Sans Condensed', sans-serif",
      "https://fonts.googleapis.com/css?family=Open+Sans+Condensed:300"
    ],
    ["'Ubuntu', sans-serif", "https://fonts.googleapis.com/css?family=Ubuntu"],
    ["'Arimo', sans-serif", "https://fonts.googleapis.com/css?family=Arimo"],
    ["'Lobster', cursive", "https://fonts.googleapis.com/css?family=Lobster"],
    ["'Exo 2', sans-serif", "https://fonts.googleapis.com/css?family=Exo+2"],
    ["'Play', sans-serif", "https://fonts.googleapis.com/css?family=Play"],
    [
      "'Russo One', sans-serif",
      "https://fonts.googleapis.com/css?family=Russo+One"
    ],
    ["'Neucha', cursive", "https://fonts.googleapis.com/css?family=Neucha"],
    [
      "'Rubik One', sans-serif",
      "https://fonts.googleapis.com/css?family=Rubik+One"
    ],
    ["'Pattaya', sans-serif", "https://fonts.googleapis.com/css?family=Pattaya"],
    [
      "'Kelly Slab', cursive",
      "https://fonts.googleapis.com/css?family=Kelly+Slab"
    ],
    [
      "'Prosto One', cursive",
      "https://fonts.googleapis.com/css?family=Prosto+One"
    ]
  ];

  export default {
      FONTS
    }